import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_USER, GET_USER_BY_ID } from "../constants";

export const getUser = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/customers`, { params: data });
    if (response?.data?.status) {
      dispatch({ type: GET_USER, userlist: response?.data?.response });
      // return response;
    }
    else {
      dispatch({ type: GET_USER, userlist: [] });
    } 
  } catch (err) {
   // console.error(err);
    dispatch({ type: GET_USER, userlist: [] });
  }
};

export const addUser = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/customers", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/user")
      return response;
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const updateUser = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("admin/customers", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/user")
      return response;
    }
   else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
   }
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const deleteUser = (id, setLoading, params) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`admin/customers/${id}`);
    if (response?.data?.status) {
      dispatch(getUser(params));
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getUserById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/customers/${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_USER_BY_ID, userbyid: response.data.response });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
  }
};


export const addUserNotification = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/customers/push-notification", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/user")
      return response;
    }
    else{
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }

  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};